import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Theme } from '@radix-ui/themes';

import '@radix-ui/themes/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import '@/styles/globals.scss';

import { prepareBrowserAuth } from '@/lib/auth-reset';

// DEBUG
// Expose gs on window for browser-console debugging.
// import { gs } from '@/models/GlobalState';

// (window as any).gs = gs;

const root = createRoot(document.getElementById('root')!);

async function startApplication() {
  try {
    await prepareBrowserAuth();
  } catch {
    root.render(
      <div role="alert">
        <p>
          AWARE sign-in is temporarily unavailable. Please retry.
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          Retry
        </button>
      </div>
    );
    return;
  }

  // A static import would start GlobalState/session requests before the reset.
  const { default: App } = await import('@/App');
  root.render(
    <StrictMode>
      <div className="aware antialiased">
        <Theme>
          <App />
        </Theme>
      </div>
    </StrictMode>
  );
}

void startApplication();
